// Author: Kalyan Bikram Adhikari
// Created-Date:
// Modified-Date:

import React, { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "../components/Button";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import LeftSection from "./LeftSection";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// toast
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useResetPasswordMutation } from "../store/APIFeatures/userAPIs";
import { useForgotPasswordMutation } from "../store/APIFeatures/userAPIs";

// slices of toolkit

const ResetPassword = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const [resetPassword, { data, isLoading, isSuccess, status }] =
    useResetPasswordMutation();
  // const [forgotPassword, { data, isLoading, isSuccess, status }] = useForgotPasswordMutation()

  const location = window.location.origin;
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);

  const email = urlParams.get("email"); // Decodes the email
  const token = urlParams.get("token");
  // const token = window.location.token
  // const email = window.location.email

  // console.log('location', location)

  // useEffect(() => {
  //     if (isSuccess) {

  //         toast.success('Your password has been reset sucessfully')

  //     }
  //     // if (status === 'rejected') {
  //     //     console.log('login failed')
  //     // }
  // }, [isSuccess, status])

  return (
    <div>
      <Formik
        initialValues={{
          password: "",
          confirmpassword: "",
        }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .min(8, "Password must be at least 8 characters")
            .required("Password is required"),
          confirmpassword: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords must match")
            .required("Confirm Password is required"),
        })}
        onSubmit={async ({ password, confirmpassword }) => {
          if (password && confirmpassword) {
            try {
              const resetResponse = await resetPassword({
                email,
                newPassword: password,
                confirmPassword: confirmpassword,
                token,
                clientUrl: location,
              });
              if (resetResponse?.data) {
                toast.success("Password reset successfully!");
              } else if (resetResponse?.error) {
                toast.error(resetResponse.error.data.message || "Reset failed");
              }
            } catch (error) {
              toast.error("An unexpected error occurred");
              console.error(error);
            }
          } else {
            toast.error("Please fill out all fields correctly");
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => {
          return (
            <form noValidate onSubmit={handleSubmit}>
              <div className="flex flex-col lg:h-screen md:flex-row">
                {/* left section of the login code */}
                <div className="flex flex-col  md:fixed md:h-screen md:left-0 md:w-1/2 md:p-8 md:gap-y-32 md:bg-primary-background ">
                  <Link to="/">
                    <div className="hidden md:block">
                      <img
                        src="/assets/images/Logo.png"
                        alt=""
                        className="h-16"
                      />
                    </div>
                  </Link>
                  <div className="flex justify-center items-center mb-6 mt-12 md:hidden ">
                    <span className="text-xl text-primary-title font-poppins font-semibold ">
                      Reset Password
                    </span>
                  </div>
                  <div className="flex justify-center items-center">
                    <img
                      src="/assets/images/login.png"
                      alt=""
                      className="h-60 md:h-80 "
                    />
                  </div>
                </div>
                {/* right section of the login code */}

                <div className=" w-full md:w-1/2 md:ml-auto ">
                  <div className="md:mt-32 lg:px-32 xl:px-44 2xl:px-52 lg:p-10 p-4  md:space-y-10 ">
                    <div className=" text-primary-title font-poppins text-xl font-semibold hidden md:flex md:justify-center">
                      <span className="text-2xl">Reset Password</span>
                    </div>
                    <div>
                      <div className="flex flex-col space-y-4 p-4  ">
                        <span className="font-poppins  md:text-base">
                          Password*{" "}
                        </span>
                        <div className="relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            value={values.password}
                            name="password"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            className={`border-[1px] border-gray-400 p-1 h-10 px-2 rounded-lg outline-none w-full ${
                              touched.password && errors.password
                                ? "border-red-500"
                                : "border-gray-400"
                            }`}
                          />
                          <div
                            className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? (
                              <VisibilityOffIcon className="w-5 h-5" />
                            ) : (
                              <RemoveRedEyeIcon className="w-5 h-5" />
                            )}
                          </div>
                        </div>

                        {touched.password && errors.password && (
                          <span error className="text-red-500">
                            {errors.password}
                          </span>
                        )}
                      </div>

                      <div className="flex flex-col space-y-4 p-4  ">
                        <span className="font-poppins  md:text-base">
                          Confirm Password*{" "}
                        </span>
                        <div className="relative">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirmpassword"
                            value={values.confirmpassword}
                            name="confirmpassword"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="Re-enter your password"
                            className={`border-[1px] border-gray-400 p-1 h-10 px-2 rounded-lg outline-none w-full ${
                              touched.password && errors.password
                                ? "border-red-500"
                                : "border-gray-400"
                            }`}
                          />
                          <div
                            className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                            onClick={handleClickShowConfirmPassword}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOffIcon className="w-5 h-5" />
                            ) : (
                              <RemoveRedEyeIcon className="w-5 h-5" />
                            )}
                          </div>
                        </div>
                        {touched.confirmpassword && errors.confirmpassword && (
                          <span className="text-red-500">
                            {errors.confirmpassword}
                          </span>
                        )}
                      </div>

                      <div className=" p-4">
                        {/* <Button title="Send Email" className="w-full rounded-md" /> */}
                        <button
                          type="submit"
                          className="w-full rounded-md bg-cyan-800 p-2 px-4 text-lg text-white"
                        >
                          Reset Password
                        </button>
                      </div>
                      <div className="flex items-center px-4 ">
                        <hr className="flex-grow border-t border-gray-300" />
                        <span className="mx-4 text-gray-500">Or</span>
                        <hr className="flex-grow border-t border-gray-300" />
                      </div>

                      <div className="flex justify-center mt-6  ">
                        <span className="font-medium text-sm font-poppins ">
                          Go back to ?
                          <Link to="/">
                            <span className="font-poppins text-[#448eb6] font-medium text-sm ml-2">
                              Home
                            </span>
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ResetPassword;
